import { _ as __assign } from '../../chunks/bundle-BsoKutlt.js';
import React__default from 'react';
import { F as FileViewerView } from '../../chunks/bundle-Brb15PE2.js';
import { useChannelContext } from '../context.js';
import 'react-dom';
import '../../chunks/bundle-DFFEB3Ap.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-By8wnYCK.js';
import '../../chunks/bundle-Bpnh459j.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-C8lF82nA.js';
import '../../chunks/bundle-D9fAlnnY.js';
import '../../chunks/bundle-ChbTBhrO.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-CtiWV1fp.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-CoaHGciJ.js';
import '../../chunks/bundle-BXx8qybA.js';
import '../../chunks/bundle-K-ZPPQr-.js';
import '../../chunks/bundle-DleO6yp8.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-DDQiHUtN.js';
import '../../chunks/bundle-Cdxj4urY.js';
import '../../chunks/bundle-Qz21XT9v.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-B_S6iTLS.js';
import '../../chunks/bundle-DqiG00CL.js';
import '../../chunks/bundle-Dcu4oaT9.js';
import '../../chunks/bundle-SFTC4POJ.js';
import '../../chunks/bundle-JoxrNKuk.js';
import '../../chunks/bundle-BsRE6o7w.js';
import '../../chunks/bundle-Bect-58W.js';
import '../../chunks/bundle-D8tzsrR-.js';
import '../../chunks/bundle-B-5tutOE.js';
import '../../chunks/bundle-B0uMDJtX.js';
import '../../chunks/bundle-BmAH27TX.js';
import '../../chunks/bundle-CKHpBJK8.js';

var FileViewer = function (props) {
    var deleteMessage = useChannelContext().deleteMessage;
    return React__default.createElement(FileViewerView, __assign({}, props, { deleteMessage: deleteMessage }));
};

export { FileViewer, FileViewer as default };
//# sourceMappingURL=FileViewer.js.map
